import React from 'react'

import Wizard from '@modules/form-wizard'
import { common } from './common/duty-free'
import { BUSINESS_FIELDS } from '@modules/form-wizard/utils'
import islands from '@constants/islands'
// import ENV from '@constants/env'

export default class DutyFreeCommercialFishing extends React.Component {
  resource = '/duty_free_commercial_fishings'
  form_key = 'duty_free_commercial_fishing'
  free = true

  defaults = {
    equipment: true,
  }

  read_params = {
    // admin: true,
    label: ' ',
    default: 'Default',
    values: {
      'Default': {
        equipment: true,
      },
    },
  }

  business_only = true
  skip_location = true

  metadata = {
    denied: { license_numb: '####' }
  }

  canned = {
    'TEST CANNED': `
      This is a test canned message; it can be whatever you like.
    `
  }

  hide_buttons = {
    approve: true,
    status: true,
    deny: true
  }

  // Imported from Common - duty-free.js
  custom_actions = []

  fields = form => [
    {
      name: 'equipment',
      label: 'Duty Free Commercial Fishing Equipment form',
      type: 'select:bool',
      // view: true,
      save: true,
      hide: true,
    },
    ...BUSINESS_FIELDS(form),
    {
      name: 'phone',
      is: 'phone',
      use_profile: 'additional_phone_number',
    },
    {
      name: 'po_box',
      label: 'P. O. Box',
      required: false,
    },
    {
      name: 'nationality',
      use_profile: 'country_of_citizenship',
      disabled: true,
      view: {
        value: v => v?.initialCaps()
      }
    },
    {
      name: 'company_name',
      label: 'Name of Company',
    },
    '::Captain Detais',
    {
      name: 'captain',
      type: 'select:bool',
      label: 'Are you the intended captain?',
      view: {
        hide: !form.captain,
        label: 'Is Own Intended Captain',
        value: v => v ? 'Yes' : 'No',
      },
    },
    {
      name: 'captain_license_numb',
      label: 'Captain Licence #'
    },
    {
      name: 'captain_first_name',
      label: 'First Name',
      hide: form.captain !== false,
    },
    {
      name: 'captain_last_name',
      label: 'Last Name',
      hide: form.captain !== false,
    },
    {
      name: 'captain_license_upload',
      key: 'image.8',
      type: 'file:image',
      label: 'Copy of Captain Licence',
    },
    // {
    //   name: 'captain_nationality',
    //   label: 'Nationality',
    //   hide: form.captain !== false,
    //   options: countries,
    // },

    '::Equipment Details',
    {
      type: 'textarea',
      name: 'vessel_fixed_gear',
      label: 'Fixed Fishing Gear',
      hint: 'Winches, reels, haulers, etc.',
    },
    {
      type: 'textarea',
      name: 'vessel_expandable_gear',
      label: 'Expandable Fishing Gear',
      hint: 'Winches, reels, haulers, etc.',
    },
    {
      name: 'vessel_electric_apparatus',
      required: false,
      label: 'Electric Apparatus',
      type: 'textarea',
      hint: 'Electric reels/winches, other electronics, etc.',
    },

    '::Registration Details',
    {
      name: 'vessel_registry_port',
      label: 'Port of Registry',
      // options: ports,
      required: false,
      hint: 'Omit if not available',
    },
    {
      name: 'vessel_registry_number',
      label: 'Port Official Number',
      required: false,
      hint: 'Omit if not available',
    },
    {
      name: 'vessel_home_port',
      label: 'Intended Home Port',
      // options: ports,
    },
    {
      name: 'fishing_areas',
      label: 'Main Fishing Areas',
      options: islands,
      multi: true,
      hint: 'Select all that apply'
    },
    {
      name: 'vessel_value',
      is: 'currency',
      label: 'Value of Equipment',
    },
  ]

  hidden_fields = () => [
    {
      name: 'pdf_upload',
      type: 'file:pdf',
      label: 'Certificate of Registration',
      key: 'image.0',
    },
  ]

  render = () => <Wizard {...common(this)} />
}
